import Vue from 'vue';

let handle: number | undefined;

const store = Vue.observable({
  base: '/',
  started: false,
  lastModified: null as string | null,
  updateAvailable: false,
  errorsCount: 0,
  latestError: null as Error | null,
});

export const setupChecker = (opts: { base: string }) => {
  const newOpts = { ...opts };
  let { base } = newOpts;
  if (base) {
    if (!base.endsWith('/')) {
      base = `${base}/`;
    }
    store.base = base;
  }
};

const _checkForUpdates = () => {
  // Cache busting - jQuery style
  const timestamp = +new Date();
  fetch(`${store.base}manifest.json?_=${timestamp}`, {
    method: 'HEAD',
    headers: { 'content-type': 'application/json; charset=utf-8' },
    cache: 'no-cache',
    credentials: 'omit',
  })
    .then(res => {
      // NOTE: This header is usually not available during development
      const value = res.headers.get('last-modified');
      if (!value) {
        return;
      }
      const { lastModified } = store;
      if (lastModified !== value) {
        store.lastModified = value;
        if (lastModified !== null) {
          store.updateAvailable = true;
        }
      }
    })
    .catch(err => {
      if (store.errorsCount === 0) {
        window.console.warn(
          'Error while checking for manifest update (only shown once):',
        );
        window.console.error(err);
      }
      store.errorsCount += 1;
      store.latestError = err;
    });
};

export const createThrottledChecker = (seconds = 1) => {
  const ms = Number.isNaN(seconds) ? 1000 : Math.max(seconds * 1000, 1000);
  let enabled = true;
  return () => {
    if (!enabled) {
      return;
    }
    enabled = false;
    _checkForUpdates();
    setTimeout(() => {
      enabled = true;
    }, ms);
  };
};

export const checkForUpdates = createThrottledChecker();

export function stopChecking() {
  if (handle) {
    clearInterval(handle);
    handle = undefined;
    store.started = false;
  }
}

export function startChecking({
  immediate = true,
  frequencyMs = 300 * 1000,
} = {}) {
  stopChecking();
  handle = setInterval(checkForUpdates, frequencyMs);
  store.started = true;
  if (immediate) {
    checkForUpdates();
  }
  return stopChecking;
}

export default {
  get lastModified() {
    return store.lastModified;
  },
  get updateAvailable() {
    return store.updateAvailable;
  },
  get errorsCount() {
    return store.errorsCount;
  },
  get latestError() {
    return store.latestError;
  },
  clearLatestError() {
    store.latestError = null;
  },
};
